<template>
  <div class="h-100 timeline-bar-container">
    <h2 class="timeline-card-title text-main">Timeline</h2>
    <div v-if="loading">
      <alert class="my-2" />
    </div>
    <div
      v-if="!loading && filteredTimeline"
      class="timeline-dashboard-container"
    >
      <alert class="my-2" v-if="filteredTimeline.length == 0">No Items</alert>

      <template v-if="filteredTimeline.length > 0">
        <div class="timeline-list">
          <div
            v-for="task in filteredTimeline"
            :key="task.id"
            class="timeline-item"
          >
            <img
              class="avatar-task-img rounded-circle"
              alt=""
              :src="
                (task.type == 'TAGGED_IN_TASK' ||
                task.type == 'TAGGED_IN_TASK_UPDATE' ||
                task.type == 'TAGGED_IN_TASK_REPLY'
                  ? task.subscriber.profile_picture
                  : task.publisher.profile_picture) || profileImagePlaceholder
              "
            />
            <div class="item-content">
              <div class="timeline-date-info">
                <p class="user-name mb-0">{{ task.details.name }}</p>
                <p class="date-time mb-0">{{ formattedDate(task.due_date) }}</p>
              </div>
              <div class="timeline-subject">
                <div class="two-lines" v-html="task.details.description"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="see-all-timeline pointer-cursor d-flex justify-content-between"
          @click="navigateToTimeline"
        >
          <span>See all</span> <i class="fas fa-chevron-right"></i>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import * as dayjs from "dayjs";
import data from "emoji-mart-vue-fast/data/google.json";
import { EmojiIndex } from "emoji-mart-vue-fast/src";
import { orderBy } from "lodash";
import Swal from "sweetalert2";
import { mapActions, mapState } from "vuex";
let emojiIndex = new EmojiIndex(data);

export default {
  name: "timeline-bar",
  props: ["userId", "maxItems"],
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      patient: (state) => state.patients.patient,
      serverTaskTypes: (state) => state.task.taskTypes.data,
    }),
    filteredTimeline: function () {
      let filteredItems = this.timeLine;
      if (this.timeLine && this.timeLine.length && this.type != "-1") {
        if (this.type == "-2") {
          filteredItems = this.timeLine.filter(
            (item) =>
              item.type.indexOf("_TASK") > -1 ||
              item.type.indexOf("TAGGED_IN_REPLY") > -1
          );
        } else {
          filteredItems = this.timeLine.filter(
            (item) =>
              item.type == this.type || item.type == `${this.type}_UPDATE`
          );
        }
      }
      if (this.selectedTaskType != "-1") {
        filteredItems = filteredItems.filter(
          (item) => item.related_record_type == this.selectedTaskType
        );
      }
      if (this.maxItems) {
        filteredItems = filteredItems.slice(0, this.maxItems);
      }
      return filteredItems;
    },
    actionTypeRelatedToTask: function () {
      return (
        this.type == "-2" ||
        this.type.indexOf("_TASK") > -1 ||
        this.type.indexOf("TAGGED_IN_REPLY") > -1
      );
    },
    taskTypes: function () {
      return [
        { value: "-1", label: "Select Task Type" },
        ...this.serverTaskTypes
          .map((type) => {
            return {
              value: type.type_id,
              label: type.name,
            };
          })
          .sort((a, b) => {
            return a.label.localeCompare(b.label);
          }),
      ];
    },
  },
  created() {
    this.getTaskTypes();
    this.getProviders().then(() => {
      this.getRelatedTask();
    });
  },
  methods: {
    ...mapActions({
      getTaskTypes: "task/getTaskTypes",
    }),
    navigateToTimeline: function () {
      this.$router.push({ path: "/tasks" });
    },
    checkSelectedTaskType() {
      if (
        this.type !== "-2" &&
        this.type.indexOf("_TASK") == -1 &&
        this.type.indexOf("TAGGED_IN_REPLY") == -1
      ) {
        this.selectedTaskType = "-1";
      }
    },
    getFolderNavigationUrl(activityItem) {
      var activityTypeObject = this.activitiyTypeMap[activityItem.type];
      if (
        activityItem.subscriber.isAdmin ||
        activityItem.subscriber.isManagingAdmin
      ) {
        return activityTypeObject.adminUrlNavigation;
      } else if (activityItem.subscriber.isPatient) {
        return activityTypeObject.patientUrlNavigation.replace(
          "id_replace",
          this.patient.id
        );
      } else if (activityItem.subscriber.isProvider) {
        const provider = this.providers.filter(
          (prov) => prov.user_id == activityItem.subscriber.id
        )[0];
        return activityTypeObject.providerUrlNavigation.replace(
          "id_replace",
          (provider || {}).id
        );
      }
      return "";
    },
    generateAcitivyDescriptionFromActivity(activityItem) {
      if (activityItem.publisher != null) {
        var activityTypeObject = this.activitiyTypeMap[activityItem.type];
        if (activityTypeObject != null) {
          if (activityItem.type == "TASK_REACTION") {
            return {
              name:
                activityItem.publisher.last +
                ", " +
                activityItem.publisher.first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                activityTypeObject.urlNavigation +
                "/" +
                +activityItem.related_record_id +
                "'" +
                "> <span class='activityName'>" +
                (activityItem.related_record_name ||
                  activityTypeObject.urlDsiplayText) +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                `<span class='task-emoji'>
                ${this.findEmoji(activityItem.reaction)}
              </span>`,
            };
          } else if (activityItem.type == "REPLY_REACTION") {
            return {
              name:
                activityItem.publisher.last +
                ", " +
                activityItem.publisher.first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                activityTypeObject.urlNavigation +
                "/" +
                activityItem.related_record_id +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "") +
                "'" +
                "> <span class='activityName'>" +
                activityItem.related_record_name +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                `<span class='task-emoji'>
                ${this.findEmoji(activityItem.reaction)}
              </span>`,
            };
          } else if (activityItem.type == "ASSIGNED_TASK_REPLY") {
            return {
              name:
                activityItem.publisher.last +
                ", " +
                activityItem.publisher.first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                activityTypeObject.urlNavigation +
                "/" +
                activityItem.related_record_id +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "") +
                "'" +
                "> <span class='activityName'>" +
                activityItem.related_record_name +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                " <span class='timeline-user-name'>" +
                activityItem.subscriber.last +
                ", " +
                activityItem.subscriber.first +
                (activityTypeObject.post2DisplayText || "") +
                "</span>",
            };
          } else if (activityItem.type == "TAGGED_IN_REPLY") {
            return {
              name:
                activityItem.subscriber.last +
                ", " +
                activityItem.subscriber.first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                activityTypeObject.urlNavigation +
                "/" +
                activityItem.related_record_id +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "") +
                "'" +
                "> <span class='activityName'>" +
                activityItem.related_record_name +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                " <span class='timeline-user-name'>" +
                activityItem.publisher.last +
                ", " +
                activityItem.publisher.first +
                "</span>",
            };
          } else if (activityItem.type == "AUTHOR_TASK_REPLY") {
            return {
              name:
                activityItem.publisher.last +
                ", " +
                activityItem.publisher.first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                activityTypeObject.urlNavigation +
                "/" +
                activityItem.related_record_id +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "") +
                "'" +
                "> <span class='activityName'>" +
                activityItem.related_record_name +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                " <span class='timeline-user-name'>" +
                activityItem.subscriber.last +
                ", " +
                activityItem.subscriber.first +
                "</span>",
            };
          } else if (activityItem.type == "AUTHOR_TASK_REPLY_UPDATE") {
            return {
              name:
                activityItem.publisher.last +
                ", " +
                activityItem.publisher.first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                activityTypeObject.urlNavigation +
                "/" +
                activityItem.related_record_id +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "") +
                "'" +
                "> <span class='activityName'>" +
                activityItem.related_record_name +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                " <span class='timeline-user-name'>" +
                activityItem.subscriber.last +
                ", " +
                activityItem.subscriber.first +
                "</span>",
            };
          } else if (activityItem.type == "ASSIGNED_TASK_REPLY_UPDATE") {
            return {
              name:
                activityItem.publisher.last +
                ", " +
                activityItem.publisher.first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                activityTypeObject.urlNavigation +
                "/" +
                activityItem.related_record_id +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "") +
                "'" +
                "> <span class='activityName'>" +
                activityItem.related_record_name +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                " <span class='timeline-user-name'>" +
                activityItem.subscriber.last +
                ", " +
                activityItem.subscriber.first +
                (activityTypeObject.post2DisplayText || "") +
                "</span>",
            };
          } else {
            return {
              name:
                (activityItem.type == "TAGGED_IN_TASK" ||
                activityItem.type == "TAGGED_IN_TASK_UPDATE" ||
                activityItem.type == "TAGGED_IN_TASK_REPLY"
                  ? activityItem.subscriber
                  : activityItem.publisher
                ).last +
                ", " +
                (activityItem.type == "TAGGED_IN_TASK" ||
                activityItem.type == "TAGGED_IN_TASK_UPDATE" ||
                activityItem.type == "TAGGED_IN_TASK_REPLY"
                  ? activityItem.subscriber
                  : activityItem.publisher
                ).first,
              description:
                activityTypeObject.preDisplayText +
                "<a target='_blank' href='" +
                (activityItem.type == "SHARED_IN_FOLDER" ||
                activityItem.type == "SHARED_IN_DOCUMENT"
                  ? this.getFolderNavigationUrl(activityItem)
                  : activityTypeObject.urlNavigation +
                    "/" +
                    activityItem.related_record_id) +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "") +
                "'" +
                "> <span class='activityName'>" +
                (activityItem.related_record_name ||
                  activityTypeObject.urlDsiplayText) +
                "</span> </a> " +
                activityTypeObject.postDisplayText +
                " <span class='timeline-user-name'>" +
                (activityItem.subscriber != null
                  ? (activityItem.type == "TAGGED_IN_TASK" ||
                    activityItem.type == "TAGGED_IN_TASK_UPDATE"
                      ? activityItem.publisher
                      : activityItem.subscriber
                    ).last +
                    ", " +
                    (activityItem.type == "TAGGED_IN_TASK" ||
                    activityItem.type == "TAGGED_IN_TASK_UPDATE"
                      ? activityItem.publisher
                      : activityItem.subscriber
                    ).first
                  : "") +
                (activityTypeObject.post2DisplayText || "") +
                "</span>",
            };
          }
        }
      } else {
        return {
          name: "N/A",
          description: "N/A",
        };
      }
    },
    generateActivityLink(activityItem) {
      if (activityItem.publisher != null) {
        var activityTypeObject = this.activitiyTypeMap[activityItem.type];
        if (activityTypeObject != null) {
          return activityItem.type == "SHARED_IN_FOLDER" ||
            activityItem.type == "SHARED_IN_DOCUMENT"
            ? this.getFolderNavigationUrl(activityItem)
            : activityTypeObject.urlNavigation +
                "/" +
                +activityItem.related_record_id +
                (activityItem.related_reply_id
                  ? `?reply_id=${activityItem.related_reply_id}`
                  : "");
        }
        return undefined;
      } else {
        return undefined;
      }
    },
    formattedDate: function (dateToformat) {
      if (dateToformat && dateToformat != "") {
        return dayjs(dateToformat).format("MMMM DD・hh:mm A");
      } else {
        return "";
      }
    },
    getRelatedTask: async function () {
      try {
        this.loading = true;
        const extra_params = this.maxItems ? `&size=${this.maxItems}` : "";
        const res = await this.$http.get(
          `basic-timeline?user_id=` + this.userId + extra_params
        );
        res.data.data.filter((item) => {
          this.timeLine.push({
            id: item.id,
            details: this.generateAcitivyDescriptionFromActivity(item),
            due_date: item.created_at,
            type: item.type,
            publisher: item.publisher,
            subscriber: item.subscriber,
            messageBody: item.description,
            link: this.generateActivityLink(item),
            related_record_name: item.related_record_name,
            related_reply_id: item.related_reply_id,
            related_record_type: item.related_record_type,
            displayType: item.related_record_type
              ? this.getTypeName(item.related_record_type)
              : null,
            className: item.related_record_type
              ? this.getTaskColor(item.related_record_type)
              : null,
          });
        });
        this.timeLine = orderBy(this.timeLine, ["due_date"], ["desc"]);
        this.loading = false;
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: "Error on getting the data",
          icon: "error",
        });
        this.timeLine = [];
        this.loading = false;
      }
    },
    getTypeName(type) {
      return (this.taskTypes.filter((item) => item.value == type)[0] || {})
        .label;
    },
    getTaskColor(type) {
      let className = "";
      switch (type) {
        case "1":
          className = "btn-secondary";
          break;
        case "2":
          className = "btn-info";
          break;
        case "3":
          className = "btn-secondary";
          break;
        case "4":
          className = "btn-deep-red";
          break;
        case "5":
          className = "btn-info";
          break;
        case "6":
          className = "btn-info";
          break;
        case "7":
          className = "btn-secondary";
          break;
        case "8":
          className = "btn-info";
          break;
        case "9":
          className = "btn-7ac98b";
          break;
        case "10":
          className = "btn-info";
          break;
        case "11":
          className = "btn-deep-red";
          break;
        case "12":
          className = "btn-deep-warning";
          break;
        case "13":
          className = "btn-warning";
          break;
        case "14":
          className = "btn-success";
          break;
        case "15":
          className = "btn-deep-success";
          break;
        case "16":
          className = "btn-danger";
          break;

        case "17":
          className = "btn-danger";
          break;
        case "18":
          className = "btn-deep-red";
          break;
        case "19":
          className = "btn-info";
          break;
        case "20":
          className = "btn-7ac98b";
          break;
        case "21":
          className = "btn-639db9";
          break;
        case "22":
          className = "btn-a84bc6";
          break;
        case "23":
          className = "btn-e27c1d";
          break;
        case "24":
          className = "btn-e0511d";
          break;
        case "25":
          className = "btn-dd1c59";
          break;
        case "26":
          className = "btn-a31cdd";
          break;
        case "27":
          className = "btn-0859d3";
          break;
        case "28":
          className = "btn-157477";
          break;
        case "29":
          className = "btn-1a3f3f";
          break;
        case "30":
          className = "btn-0d62a8";
          break;
        case "39":
          className = "btn-dark";
          break;
        case "40":
          className = "btn-deep-red";
          break;
        default:
          className = "btn-danger";
          break;
      }
      return className;
    },
    getProviders: function () {
      const vm = this;
      return new Promise(function (resolve) {
        vm.$store
          .dispatch("providers/getProvidersUsersIds", { id: true, local: true })
          .then((providers) => {
            vm.providers = providers;
            resolve();
          });
      });
    },
    findEmoji: function (emoji) {
      return this.emojiIndex.findEmoji(emoji)?.native;
    },
  },
  data() {
    return {
      loading: true,
      timeLine: [],
      providers: [],
      listDisplay: !this.maxItems,
      type: "-1",
      selectedTaskType: "-1",
      activitiyTypeMap: {
        ASSIGNED_TASK: {
          preDisplayText: "Assigned task (",
          urlDsiplayText: "task",
          postDisplayText: ") to",
          urlNavigation: "/tasks/update",
        },
        ASSIGNED_TASK_UPDATE: {
          preDisplayText: "Assigned updated task (",
          urlDsiplayText: "task",
          postDisplayText: ") to",
          urlNavigation: "/tasks/update",
        },
        ASSIGNED_TASK_REPLY: {
          preDisplayText: "Replied to task (",
          postDisplayText: ") assigned to",
          urlDsiplayText: "task",
          urlNavigation: "/tasks/update",
        },
        ASSIGNED_TASK_REPLY_UPDATE: {
          preDisplayText: "Modified a reply on task (",
          postDisplayText: ") assigned to",
          urlDsiplayText: "task",
          urlNavigation: "/tasks/update",
        },
        TAGGED_IN_REPLY: {
          preDisplayText: "Has been tagged in a reply for task (",
          postDisplayText: ") by",
          urlNavigation: "/tasks/update",
        },
        AUTHOR_TASK_REPLY: {
          preDisplayText: "Replied on a task (",
          postDisplayText: ") created by",
          urlNavigation: "/tasks/update",
        },
        AUTHOR_TASK_REPLY_UPDATE: {
          preDisplayText: "Modified a reply on a task (",
          postDisplayText: "). task created by",
          urlNavigation: "/tasks/update",
        },
        TAGGED_IN_TASK: {
          preDisplayText: "Has been tagged in task (",
          postDisplayText: ") by",
          urlDsiplayText: "task",
          urlNavigation: "/tasks/update",
        },
        TAGGED_IN_TASK_UPDATE: {
          preDisplayText: "Has been tagged in updated task (",
          postDisplayText: ") by",
          urlDsiplayText: "task",
          urlNavigation: "/tasks/update",
        },
        TAGGED_IN_TASK_REPLY: {
          preDisplayText: "Replied to task (",
          postDisplayText: ") where",
          post2DisplayText: " tagged in",
          urlDsiplayText: "task",
          urlNavigation: "/tasks/update",
        },
        SHARED_IN_FOLDER: {
          preDisplayText: "Shared the folder (",
          postDisplayText: ") with",
          urlDsiplayText: "folder",
          adminUrlNavigation: "/admin/documents",
          patientUrlNavigation: "/clients/id_replace/documents",
          providerUrlNavigation: "/providers/id_replace/documents",
        },
        SHARED_IN_DOCUMENT: {
          preDisplayText: "Shared the file (",
          postDisplayText: ") with",
          urlDsiplayText: "file",
          adminUrlNavigation: "/admin/documents",
          patientUrlNavigation: "/clients/id_replace/documents",
          providerUrlNavigation: "/providers/id_replace/documents",
        },
        TASK_REACTION: {
          preDisplayText: "Reacted to task (",
          postDisplayText: ") with ",
          urlDsiplayText: "task",
          urlNavigation: "/tasks/update",
        },
        REPLY_REACTION: {
          preDisplayText: "Reacted to a reply on task (",
          postDisplayText: ") with ",
          urlDsiplayText: "task",
          urlNavigation: "/tasks/update",
        },
      },
      actionTypes: [
        { value: "-1", label: "Select Action Type" },
        { value: "-2", label: "Task Timeline" },
        { value: "ASSIGNED_TASK", label: "Assigned Task" },
        { value: "ASSIGNED_TASK_UPDATE", label: "Assigned Task Update" },
        { value: "TAGGED_IN_TASK", label: "Tagged In Task" },
        { value: "TAGGED_IN_TASK_UPDATE", label: "Tagged In Task Update" },
        { value: "ASSIGNED_TASK_REPLY", label: "Reply On Assigned Task" },
        {
          value: "ASSIGNED_TASK_REPLY_UPDATE",
          label: "Reply Update On Assigned Task",
        },
        { value: "TAGGED_IN_REPLY", label: "Tagged In Reply" },
        { value: "AUTHOR_TASK_REPLY", label: "Reply On Created Task" },
        {
          value: "AUTHOR_TASK_REPLY_UPDATE",
          label: "Reply Update On Created Task",
        },
        { value: "TAGGED_IN_TASK_REPLY", label: "Reply On Tagged In Task" },
        { value: "TASK_REACTION", label: "Reaction On Task" },
        { value: "REPLY_REACTION", label: "Reaction On Reply" },
        { value: "SHARED_IN_FOLDER", label: "Folder Share" },
        { value: "SHARED_IN_DOCUMENT", label: "File Share" },
      ],
      profileImagePlaceholder: require("@/assets/img/avatars/profiles/avatar.jpg"),
      emojiIndex: emojiIndex,
    };
  },
};
</script>

<style scoped lang="scss">
$card-border: #e6e9ee;
$avatar: 44px;

.timeline-bar-container {
  background-color: #ffffffb8;
  border: 1px solid $card-border;
  border-radius: 22px;
  box-shadow: 0 6px 20px rgba(16, 24, 40, 0.06);
  padding: 24px;

  .timeline-card-title {
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 18px;
  }
}

.timeline-dashboard-container {
  .timeline-list {
    position: relative;

    // The vertical line, through the middle of the avatars.
    &::before {
      content: "";
      position: absolute;
      left: calc(#{$avatar} / 2 - 1px);
      top: 8px;
      bottom: 8px;
      width: 2px;
      background-color: #3d4650;
      border-radius: 2px;
    }
  }

  .timeline-item {
    position: relative;
    display: flex;
    align-items: flex-start;

    & + .timeline-item {
      margin-top: 16px;
    }
  }

  .avatar-task-img {
    position: relative;
    z-index: 1;
    flex: 0 0 $avatar;
    width: $avatar;
    height: $avatar;
    object-fit: cover;
    border: 3px solid #ffffff;
    box-shadow: 0 0 0 1px $card-border, 0 2px 6px rgba(16, 24, 40, 0.15);
    margin-right: 12px;
    background-color: #ffffff;
  }

  .item-content {
    flex: 1 1 auto;
    min-width: 0;
    border-radius: 14px;
    overflow: hidden;
    border: 1px solid $card-border;
    box-shadow: 0 4px 14px rgba(16, 24, 40, 0.06);
  }

  .timeline-date-info {
    background-color: #6c7480;
    color: #ffffff;
    padding: 9px 16px;

    .user-name {
      font-size: 15px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .date-time {
      font-size: 13px;
      font-weight: normal;
    }
  }

  .timeline-subject {
    background-color: #ffffff;
    padding: 10px 16px;
    font-size: 14px;
    color: #1f2328;
  }

  .see-all-timeline {
    margin-top: 18px;
    border-radius: 99px;
    background-color: #ffffff;
    border: 1px solid $card-border;
    padding: 11px 16px 11px 22px;
    font-weight: 600;
    color: var(--main-text-color);
    transition: border-color 0.15s;

    &:hover {
      border-color: var(--theme-color);
    }
  }
}

@media (max-width: 1024px) {
  .heading-task-content {
    &.has-badge {
      margin-top: 32px;
    }
  }
  .task-type-header-container {
    position: absolute;
    max-width: calc(100% - 48px);
    right: 30px;
    top: 13px;
  }
}
</style>
<style lang="scss">
.timeline-bar-container {
  .timeline-subject {
    .timeline-user-name {
      background-color: #0000000f;
      border-radius: 99px;
      padding: 2px 8px;
      font-weight: normal;
    }

    .task-emoji {
      border-radius: 6px;
      border: 1px solid #d2ddec;
      padding: 2px 4px;
      display: inline-block;
    }
  }
}
</style>
